import { queryKeyFactory } from "@l2r-front/l2r-query"

export const ROADSIDE_ROOT_QUERY_KEY = "roadside"

export const roadsideQueryKeys = queryKeyFactory(ROADSIDE_ROOT_QUERY_KEY, {
    conditionsStats: (parameters = {}) => [ROADSIDE_ROOT_QUERY_KEY, "conditionsStats", { parameters }],
    layer: (filters = {}) => [ROADSIDE_ROOT_QUERY_KEY, "layer", filters],
    project: (filters = {}) => [ROADSIDE_ROOT_QUERY_KEY, "project", filters],
    stats_categories: (parameters = {}) => [ROADSIDE_ROOT_QUERY_KEY, "stats", "categories", { parameters }],
    stats_conditions: (parameters = {}) => [ROADSIDE_ROOT_QUERY_KEY, "stats", "conditions", { parameters }],
    stats_inventory_types: (parameters = {}) => [ROADSIDE_ROOT_QUERY_KEY, "stats", "inventory_types", { parameters }],
    roadsideType: (code) => [ROADSIDE_ROOT_QUERY_KEY, "roadsideType", code],
    homogenousZones: (parameters = {}) => [ROADSIDE_ROOT_QUERY_KEY, "homogenousZones", { parameters }],
})
